// import React from 'react'
// import '../assets/css/Navigationbar.css'
// import Img from '../assets/images/skillslogo.png'
// import icon1 from '../assets/images/fb.png'
// import icon2 from '../assets/images/instagram.png'
// import icon3 from '../assets/images/yt.png'
// import icon4 from '../assets/images/wht.png'
// import icon5 from '../assets/images/tiktok1.png'
//
// const NavigationBar = () => {
//
//     return (
//
//         <div className='NavigationBar'>
//
//             {/* first nav bar */}
//             <nav id='nav-first-section'>
//
//                 {/* logo section */}
//                 <div className="logo" style={{padding:"20px"}}>
//                     <img src={Img} alt="skillslogo.png" width="200px" style={{padding:"20px"}} />
//                     {/* <h1>eSupport</h1> */}
//                 </div>
//
//                 {/* language-select  desk-view*/}                <div className="lan-select">
//
//                     <button><a href="/language?lang=en">English</a></button>
//                     <button><a href="/language?lang=si">සිංහල</a></button>
//                     <button><a href="/language?lang=ta">தமிழ்</a></button>
//                 </div>
//
//                 {/* mobile-view */}                <div className="menu-icon-mob-view">
//
//
//                     <select>
//                         <option value="0"><a href="!">English <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a></option>
//                         <option value="1"><a href="!">සිංහල</a></option>
//                         <option value="2"><a href="!">தமிழ் </a></option>
//
// //                     <select onChange={(e) => window.location.href = `/language?lang=${e.target.value === "0" ? "en" : e.target.value === "1" ? "si" : "ta"}`}>
// //                         <option value="0">English <i class="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></option>
// //                         <option value="1">සිංහල</option>
// //                         <option value="2">தமிழ்</option>
//
//                     </select>
//
//                 </div>
//
//             </nav>
//
//             {/* second navbar */}
//             <nav className="second-nav-bar">                <div className="icon-box-nav">
//
//
//                 {/*<div className="icon-box-nav">*/}
//
//                 {/*    <a href="!#"><img src={icon1} alt="" width={25} /></a>*/}
//                 {/*    <a href="!#"><img src={icon4} alt="" width={25} /></a>*/}
//                 {/*    <a href="!#"><img src={icon5} alt="" width={25} /></a>*/}
//                 {/*    <a href="!#"><img src={icon2} alt="" width={25} /></a>*/}
//                 {/*    <a href="!#"><img src={icon3} alt="" width={25} /></a>*/}
//                 {/*</div>*/}
//                 <div className="icon-box-nav">
//                     <a href="https://www.facebook.com/share/16ZXfRnfm5/" target="_blank" rel="noopener noreferrer">
//                         <img src={icon1} alt="Facebook" width={25}/>
//                     </a>
//                     <a href="https://whatsapp.com/channel/0029Vb5QkDi7YScwcvgVoL31" target="_blank" rel="noopener noreferrer">
//                         <img src={icon4} alt="WhatsApp" width={25}/>
//                     </a>
//                     <a href="https://www.tiktok.com/@dskills76?_t=ZS-8xKakM8lHWy&_r=1" target="_blank" rel="noopener noreferrer">
//                         <img src={icon5} alt="Tiktok" width={35}/>
//                     </a>
//                     <a href=" https://www.instagram.com/invites/contact/?igsh=13t3vvvt0oil2&utm_content=w271u8t "  target="_blank" rel="noopener noreferrer">
//                         <img src={icon2} alt="Instargram" width={30}/>
//                     </a>
//                     <a href="https://www.youtube.com/channel/UCOBC6Bjpgpncf5MhjPrWjhg" target="_blank" rel="noopener noreferrer">
//                         <img src={icon3} alt="YouTube" width={25}/>
//                     </a>
//
// //                     <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><img src={icon1} alt="Facebook" width={25} /></a>
// //                     <a href="https://wa.me/yourwhatsappnumber" target="_blank" rel="noopener noreferrer"><img src={icon4} alt="WhatsApp" width={25} /></a>
// //                     <a href="https://linkedin.com/company/yourcompany" target="_blank" rel="noopener noreferrer"><img src={icon5} alt="LinkedIn" width={25} /></a>
// //                     <a href="mailto:contact@yourdomain.com"><img src={icon2} alt="Email" width={25} /></a>
// //                     <a href="https://youtube.com/channel/yourchannel" target="_blank" rel="noopener noreferrer"><img src={icon3} alt="YouTube" width={25} /></a>
//
//                 </div>
//
//
//             </nav>
//
//             <nav className="third-nav">
//
//                 <div className="menu-list-nav2">
//
//                     <ul className=' menu-list-nav2-ul'>
//
//
//                         <li><a href="/">HOME</a></li>
//
//                         <li id="drop4">
//                             <a>COURSES <i className="fa-solid fa-caret-down" style={{color: "#fff"}}></i></a>
//
// //                         <li><a href="/">HOME</a></li>                        <li id="drop4">
// //                             <a href="/govcourses">COURSES  <i class="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//
//                             <div className="dropdown-content4">
//                                 <a href="/govcourses">Government Courses</a>
//                                 <a href="/govcourses">Private Courses</a>
//                                 {/* <a href="#">Other</a> */}
//                             </div>
//
//                         </li>
//
//                         <li id='drop3'>
//                             <a >INSTITUTES  <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//
// //                         </li>                        <li id='drop3'>
// //                             <a href="/institutes">INSTITUTES  <i class="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//
//
//                             <div className="dropdown-content3">
//                                 <a href="/institutes">Private Institutes</a>
//                                 <a href="/insfore">Foreign  Institutes</a>
//                                 {/* <a href="!#">Other</a> */}
//                             </div>
//                         </li>
//
//                         <li><a href="/studyabroad">STUDY ABROAD</a></li>
//
//                         <li><a href="/privatecourses">PRIVATE UNIVERSITIES</a></li>
//
//                         <li><a href="/professionalexams">PROFESSIONAL  EXAMS</a></li>
//
//                         <li id='drop2'>
//                             <a >REGISTER  <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//
// //                         <li><a href="/professionalexams">PROFESSIONAL  EXAMS</a></li>                        <li id='drop2'>
// //                             <a href="/stdregister">REGISTER  <i class="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//
//                             <div className="dropdown-content2">
//                                 <a href="/stdregister">Student</a>
//                                 <a href="/insregister">Institute</a>
//                             </div>
//                         </li>
//
//                         <li><a href="/externaldegree">EXTERNAL DEGREE</a></li>
//
//                         <li><a href="/alllocaljobs">LOCAL JOBS</a></li>                        <li id='drop5'>
//                             <a href="/stdloans">STUDENT LOANS  <i class="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
//                             <div className="dropdown-content2">
//                                 <a href="/createstdloan">Create Student Loan</a>
//                                 <a href="/stdloan">Find Student Loan</a>
//                                 <a href="/stdloans">All Student Loans</a>
//                             </div>
//                         </li>
//
//                         <li><a href="/allforeignjobs">FOREIGN JOBS</a></li>
//
//                         <li><a href="/events">EVENTS & NEWS</a></li>
//
//                         <li><a href="/gcview">GUIDANCE OFFICER</a></li>
//
//                         <li><a href="/Contact">CONTACT US</a></li>
//
//                         <li><a href="/aboutus">ABOUT US</a></li>
//
//                     </ul>
//
//                 </div>
//
//             </nav>
//
//         </div>
//
//     )
//
// }
//
// export default NavigationBar







import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import '../assets/css/Navigationbar.css';
import Img from '../assets/images/skillslogo.png';
import icon1 from '../assets/images/fb.png';
import icon2 from '../assets/images/instagram.png';
import icon3 from '../assets/images/yt.png';
import icon4 from '../assets/images/wht.png';
import icon5 from '../assets/images/tiktok1.png';

const NavigationBar = () => {
    const { t } = useTranslation();
    const { currentLanguage } = useLanguage();

    return (
        <div className='NavigationBar'>
            {/* first nav bar */}
            <nav id='nav-first-section'>

                {/* logo section */}
                <div className="logo" style={{ padding: "20px" }}>
                    <img src={Img} alt="skillslogo.png" width="200px" style={{ padding: "20px" }} />
                </div>

                {/* language-select  desk-view */}
                <div className="lan-select">
                    <button><a href="/language?lang=en">{t('language.english')}</a></button>
                    <button><a href="/language?lang=si">{t('language.sinhala')}</a></button>
                    <button><a href="/language?lang=ta">{t('language.tamil')}</a></button>
                </div>

                {/* mobile-view */}
                <div className="menu-icon-mob-view">
                    <select
                        value={currentLanguage}
                        onChange={(e) => {
                            const lang = e.target.value;
                            if (lang) {
                                window.location.href = `/language?lang=${lang}`;
                            }
                        }}
                    >
                        <option value="en">{t('language.english')}</option>
                        <option value="si">{t('language.sinhala')}</option>
                        <option value="ta">{t('language.tamil')}</option>
                    </select>
                </div>
            </nav>

            {/* second navbar */}
            <nav className="second-nav-bar">
                <div className="icon-box-nav">
                    <a href="https://www.facebook.com/share/16ZXfRnfm5/" target="_blank" rel="noopener noreferrer">
                        <img src={icon1} alt="Facebook" width={25} />
                    </a>
                    <a href="https://whatsapp.com/channel/0029Vb5QkDi7YScwcvgVoL31" target="_blank" rel="noopener noreferrer">
                        <img src={icon4} alt="WhatsApp" width={25} />
                    </a>
                    <a href="https://www.tiktok.com/@dskills76?_t=ZS-8xKakM8lHWy&_r=1" target="_blank" rel="noopener noreferrer">
                        <img src={icon5} alt="Tiktok" width={35} />
                    </a>
                    <a href="https://www.instagram.com/invites/contact/?igsh=13t3vvvt0oil2&utm_content=w271u8t" target="_blank" rel="noopener noreferrer">
                        <img src={icon2} alt="Instagram" width={35} />
                    </a>
                    <a href="https://www.youtube.com/channel/UCOBC6Bjpgpncf5MhjPrWjhg" target="_blank" rel="noopener noreferrer">
                        <img src={icon3} alt="YouTube" width={25} />
                    </a>
                </div>
            </nav>

            {/* third nav bar */}
            <nav className="third-nav">
                <div className="menu-list-nav2">
                    <ul className='menu-list-nav2-ul'>
                        <li><a href="/">{t('nav.home')}</a></li>

                        <li><a href="/events">{t('nav.events')}</a></li>

                         <li id='drop2'>
                            <a href="#">{t('nav.register')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="/stdregister">{t('nav.student')}</a>
                                <a href="/insregister">{t('nav.institute')}</a>
                            </div>
                        </li>

                        <li><a href="/aboutus">{t('nav.aboutUs')}</a></li>

                         <li id='drop3'>
                            <a href="#">{t('nav.institutes')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content3">
                                <a href="/institutes">{t('nav.privateInstitutes')}</a>
                                <a href="/insfore">{t('nav.foreignInstitutes')}</a>
                            </div>
                        </li>

                        <li id="drop4">
                            <a href="#">{t('nav.courses')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content4">
                                <a href="/govcourses">{t('nav.govCourses')}</a>
                                <a href="/govcourses">{t('nav.privateCourses')}</a>
                            </div>
                        </li>

                        <li><a href="/privatecourses">{t('nav.privateUniversities')}</a></li>

                        <li><a href="/studyabroad">{t('nav.studyAbroad')}</a></li>

                        <li><a href="/externaldegree">{t('nav.externalDegree')}</a></li>

                        <li><a href="/professionalexams">{t('nav.professionalExams')}</a></li>

                        <li><a href="/scholarships">{t('nav.scholarships')}</a></li>

                         <li id='drop5'>
                            <a href="#">{t('nav.studentLoans')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="/createstdloan">{t('nav.createStudentLoan')}</a>
                                <a href="/stdloan">{t('nav.findStudentLoan')}</a>
                                <a href="/stdloans">{t('nav.allStudentLoans')}</a>
                            </div>
                        </li>

                         <li id='drop5'>
                             <a href='#'>{t('nav.tvecCourses')} <i className="fa-solid fa-caret-down" style={{ color: "#fff" }}></i></a>
                            <div className="dropdown-content2">
                                <a href="#" target="_blank" rel="noopener noreferrer">{t('nav.whatIsTvec')}</a>
                                 <a href="https://www.tvec.gov.lk" target="_blank" rel="noopener noreferrer">{t('nav.tvecServices')}</a>
                                 <a href="http://www.nvq.gov.lk/TVET_GUIDE/" target="_blank" rel="noopener noreferrer">{t('nav.tvecCoursesList')}</a>
                            </div>
                        </li>

                        <li id='drop5'>
                                <a href='#' >{t('nav.govUniversity')} <i className="fa-solid fa-caret-down"></i></a>
                                <div className="dropdown-content2">
                                    <a href="https://www.ugc.ac.lk" target="_blank" rel="noopener noreferrer">{t('nav.ugcSriLanka')}</a>
                                    <a href="/govuni">{t('nav.findGovUniversities')}</a>

                                 </div>
                         </li>

                        <li><a href="/languagequalifications" >{t('nav.languageQualifications')}</a></li>


                        


                       

                        
                        
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default NavigationBar;
